import React, { useEffect, useRef } from "react";
import MultiSelect from "../common/TextField/dropDown";
import { useDispatch, useSelector } from "react-redux";
import { fetchDepsUnits } from "../Login/action";
import useConfiguration from "../../hooks/useConfiguration";
import { setValue } from "./slice";

const DepsUnits = ({value,depsUnitsRef, depsError}) => {
  const dispatch = useDispatch();
  const depsUnitsMaster = useSelector((store) => store.login.depsUnitsMaster);
  const depsUnits = useSelector((store) => store.matchingCandidateInfo.depsUnits);
  const depsUnitsChangeHandler = (e) => {
    const { action, value, name } = e;
    let copyDepsUnits = [...depsUnits];
    if (action === "add") {
      copyDepsUnits.push(value);
    } else if (action === "remove") {
      copyDepsUnits = copyDepsUnits?.filter((item) => item?.id !== value?.id);
    }
    dispatch(setValue({name,value:copyDepsUnits}))
  };

  console.log({ depsUnits });
  return (
    <div className="card">
      <p>Select departments for {value?.result?.firstName} {value?.result?.lastName} <span class="required">*</span> </p>
      <MultiSelect
        divClass={"w-100"}
        name={"depsUnits"}
        id={"depsUnits"}
        value={depsUnits}
        options={depsUnitsMaster}
        multiple={true}
        updateValue={depsUnitsChangeHandler}
        isObject={true}
        errors={depsError ? [depsError] : []}
        multiselectRef={depsUnitsRef}
      />
    </div>
  );
};

export default DepsUnits;
